import { all, takeEvery, put, call } from "redux-saga/effects";
import axiosMain from "../../../http/axios/axios_main";
import * as actionTypes from "../../actionLabels";
import * as actionUrl from "../../actions";
import CustomToast from "../../../components/Toast";

function* bidHistoryCall(action) {
  try {
    const response = yield call(
      axiosMain.post,
      "/report/bid/history",action.payload
    );

    if (response.status === 200) {
      if (response.data.statusCode === 200) {
        if(action.payload.isExport==1){
          response.data.responseData.exportType=action.payload.exportType
          yield put(actionUrl.bidHistoryExport(response.data))
        }else{
          yield put(
              actionUrl.fetchBidHistorySuccess(response.data)
          );

        }
      } else {
        CustomToast.error(response.data.message);
        yield put(
            actionUrl.fetchBidHistoryFailure(
            response.data.message
          )
        );
      }
    } else {
      CustomToast.error(
        "Failed to fetch data. Status code: " + response.status
      );
      yield put(
        actionUrl.fetchBidHistoryFailure(
          "Failed to fetch data. Status code: " + response.status
        )
      );
    }
  } catch (error) {
    console.error("Error occurred during API call:", error);
    CustomToast.error("Error occurred during API call: " + error.message);
    yield put(
        actionUrl.fetchBidHistoryFailure(
        "Error occurred during API call: " + error.message
      )
    );
  }
}
function* viewBidHistoryCall(action) {
  try {
    const response = yield call(
      axiosMain.post,
      "/report/view/bid/history",action.payload
    );

    if (response.status === 200) {
      if (response.data.statusCode === 200) {
        yield put(
            actionUrl.viewBidHistorySuccess(response.data)
        );
      } else {
        CustomToast.error(response.data.message);
        yield put(
            actionUrl.viewBidHistoryFailure(
            response.data.message
          )
        );
      }
    } else {
      CustomToast.error(
        "Failed to fetch data. Status code: " + response.status
      );
      yield put(
        actionUrl.viewBidHistoryFailure(
          "Failed to fetch data. Status code: " + response.status
        )
      );
    }
  } catch (error) {
    console.error("Error occurred during API call:", error);
    CustomToast.error("Error occurred during API call: " + error.message);
    yield put(
        actionUrl.viewBidHistoryFailure(
        "Error occurred during API call: " + error.message
      )
    );
  }
}
function* fetchBidHistoryDropdownCall(action) {
    try {
        const response = yield call(
            axiosMain.post,
            "/report/bid/history/drodownList",action.payload
        );

        if (response.status === 200) {
            if (response.data.statusCode === 200) {
                yield put(actionUrl.fetchBidHistoryDropdownSuccess(response.data));
            } else {
                CustomToast.error(response.data.message);
                yield put(actionUrl.fetchBidHistoryDropdownFailure(response.data.message));
            }
        } else {
            CustomToast.error(
                "Failed to fetch data. Status code: " + response.status
            );
            yield put(
                actionUrl.fetchBidHistoryDropdownFailure(
                    "Failed to fetch data. Status code: " + response.status
                )
            );
        }
    } catch (error) {
        console.error("Error occurred during API call:", error);
        CustomToast.error("Error occurred during API call: " + error.message);
        yield put(
            actionUrl.fetchBidHistoryDropdownFailure(
                "Error occurred during API call: " + error.message
            )
        );
    }
}
export default function* bidHistoryReportD() {
    yield takeEvery(
      actionTypes.FETCH_BID_HISTORY_REQUEST,
      bidHistoryCall
    );
    yield takeEvery(    
        actionTypes.VIEW_BID_HISTORY_REQUEST,
        viewBidHistoryCall
      );
      yield takeEvery(actionTypes.FETCH_BID_HISTORY_DROPDOWN_REQUEST, fetchBidHistoryDropdownCall);
}